<template>
  <h1 class="text-lg font-semibold">
    <slot> </slot>
  </h1>
</template>

<script>
export default {
  name: "InSectionTitle",
  components: {},
};
</script>

<style>
</style>